<template>
    <Row class="page3">
        <Col span="7">
            <div class="grid-content">
                <span class='title'><span class="title-gradient">近期投饵量分析</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <chart1 :pondsid="value" style="margin-top: 40%;"></chart1>
                <!-- <chart2 :pondsid="value"></chart2> -->
            </div>
            <!-- <div class="grid-content">
                <span class='title'><span class="title-gradient">疫情地区排行</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
            </div> -->
        </Col>
        <Col span="10" class="main">
                <div class="grid-content">
                    <span class='title'></span>
                    <span class="angle1"></span>
                    <span class="angle2"></span>
                    <span class="angle3"></span>
                    <span class="angle4"></span>
                    <clock style="font-size: 33px;"></clock>
                </div>
                <div class="grid-content" >
                    <span class='title'><span class="title-gradient">平均体长</span></span>
                    <span class="angle1"></span>
                    <span class="angle2"></span>
                    <span class="angle3"></span>
                    <span class="angle4"></span>
                    <chart5 ref="chart3" id ='bottom_2' :select-range-date="selectRangeDate" :config="cnfigData2" :pondsid="value"></chart5>
                </div>
            <div class="grid-content">
                <span class='title'><span class="title-gradient">平均体重增长情况</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <chart3 ref="chart3" id ='bottom_2' :select-range-date="selectRangeDate" :config="cnfigData1" :pondsid="value"></chart3>
            </div>
        </Col>
        <Col span="7" class="left">
            <div class="grid-content" >
                <span class='title'><span class="title-gradient">池塘信息描述</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <message :pondsid="value" ></message>
            </div>
            <!-- <div class="grid-content"  >
                <span class='title'><span class="title-gradient">饵料成分占比</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>

                <chart4 ref = 'chart4' :pondsid="value"></chart4>
            </div> -->
        </Col>
    </Row>
</template>

<script>

const chart1 = () => import('./components/page3/chart1');
// const chart2 = () => import('./components/page3/chart2');
const chart3 = () => import('./components/page3/chart3');
const clock = () => import('./components/clock');
const message = () => import('./components/page3/baseMessage');
// const chart4 = () => import('./components/page3/chart4');
const chart5 = () => import('./components/page3/chart5');
export default {
    name: "page3",
    props: ['selectRangeDate',"value"],
    components: {
        chart1,
        /*chart2,*/
        chart3,
        clock,
        message,
        // chart4,
        chart5,
    },
    data() {
        return {
            
            resizeFn: null
        }
    },
    methods: {},
    mounted() {
        this.resizeFn = this.$debounce(()=> {
            // 通过捕获系统的onresize事件触发我们需要执行的事件
           this.$refs.channelBar1.setChart();
           this.$refs.distributionSolider1.setChart();
           this.$refs.channelBar2.setChart();
           this.$refs.distributionSolider2.setChart();
            //this.$refs.pies.setPies();
           this.$refs.redPocket.setPocket();
           this.$refs.webcastsRisk.setWebcasts();
           this.$refs.deviceSafeRisk.setDeviceSafe();
           this.$refs.ring1.drawRing();
           this.$refs.ring2.drawRing();
           this.$refs.ring3.drawRing();
            for (let i = 1; i < 9; i++) {
               this.$refs['chart' + i].setChart()

            }
           this.$refs.hotWords.setChart();

        }, 500)
        window.addEventListener('resize', this.resizeFn)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeFn)
    },
}
</script>

<style lang="less" scoped>
.page3 {
    height: 100%;
    width: 100%;
    padding: 14px 20px 20px;
    background: #03044A;
    overflow: hidden;
    .ivu-col {
        height: 100%;
        display: grid;
        grid-gap: 35px;
        grid-template-rows: auto;
        &.main {
            padding: 0 20px;
            grid-template-rows: 10% 40% auto;
        }
        &.left {
            grid-template-rows: 100%;
        }
        .grid-content {
            border: 1px solid #0D2451;
            position: relative;
        }
    }
}
</style>